<template>
  <div class="navigation-buttons">
    <h2 class="subtitle">Raspored</h2>
    <div class="navigation-buttons__wrapper">
      <router-link
        v-bind:to="{
          name: 'app-schedule',
          params: { shown: 'my-schedule' },
        }"
        class="navigation-buttons__button"
      >
        <img class="navigation-buttons__button__image" src="../../../assets/app-icons/schedule/schedule.svg" />
        <span class="navigation-buttons__button__text">Moj raspored</span>
        <img class="navigation-buttons__button__chevron" src="../../../assets/app-icons/schedule/chevron.svg" />
      </router-link>
      <router-link
        v-bind:to="{ name: 'app-schedule', params: { shown: 'lecture' } }"
        class="navigation-buttons__button"
      >
        <img class="navigation-buttons__button__image" src="../../../assets/app-icons/schedule/lectures.svg" />
        <span class="navigation-buttons__button__text">Predavanja</span>
        <img class="navigation-buttons__button__chevron" src="../../../assets/app-icons/schedule/chevron.svg" />
      </router-link>
      <router-link
        v-bind:to="{ name: 'app-schedule', params: { shown: 'workshop' } }"
        class="navigation-buttons__button"
        v-if="features.workshops"
      >
        <img class="navigation-buttons__button__image" src="../../../assets/app-icons/schedule/workshops.svg" />
        <span class="navigation-buttons__button__text">Radionice</span>
        <img class="navigation-buttons__button__chevron" src="../../../assets/app-icons/schedule/chevron.svg" />
      </router-link>
      <router-link
        v-bind:to="{
          name: 'app-schedule',
          params: { shown: 'jigsawsession' },
        }"
        class="navigation-buttons__button"
        v-if="features.jigsawSessions"
      >
        <img class="navigation-buttons__button__image" src="../../../assets/app-icons/schedule/jigsaw-sessions.svg" />
        <span class="navigation-buttons__button__text">Jigsaw sessions</span>
        <img class="navigation-buttons__button__image" src="../../../assets/app-icons/schedule/chevron.svg" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonLinks',
  components: {},
  methods: {},
  props: ['features'],
};
</script>

<style scoped>
.navigation-buttons {
  max-width: 450px;
  margin-bottom: 50px;
}
.subtitle {
  font-weight: 800;
  font-size: 24px;
  line-height: 36px;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 16px;
}
.navigation-buttons__wrapper {
  display: flex;
  flex-wrap: wrap;
}
.navigation-buttons__button {
  display: flex;
  position: relative;
  border: 0;
  flex-basis: 100%;
  align-items: center;
  padding: 16px 18px 16px 24px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  text-align: left;
  transition: box-shadow 0.2s ease-in-out;
}
.navigation-buttons__button:not(:last-child) {
  margin-bottom: 8px;
}
.navigation-buttons__button:hover {
  background-color: rgba(255, 255, 255, 0.12);
}
.navigation-buttons__button__text {
  display: inline-block;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-style: normal;
  font-size: 14px;
  line-height: 17px;
  color: #fff;
  font-weight: 300;
  margin-left: 17px;
}
.navigation-buttons__button__chevron {
  margin-left: auto;
}
@media screen and (max-width: 425px) {
  .navigation-buttons__button__text {
    font-size: 13px;
    line-height: 14px;
    top: 35%;
  }
}
@media screen and (max-width: 390px) {
  .navigation-buttons-button {
    padding: 5px;
  }
  .navigation-buttons__button__text {
    font-size: 12px;
    line-height: 14px;
    top: 36%;
  }
}
@media screen and (max-width: 340px) {
  .navigation-buttons__button__text {
    font-size: 11px;
    line-height: 13px;
    top: 38%;
  }
}
@media screen and (max-width: 550px) {
  .subtitle {
    font-size: 24px;
    line-height: 29px;
  }
}
@media screen and (min-width: 550px) {
  .navigation-buttons__title {
    font-size: 40px;
    line-height: 48px;
  }
}
@media screen and (min-width: 768px) {
  .navigation-buttons__button__text {
    font-size: 16px;
    line-height: 20px;
  }
}
@media screen and (min-width: 1024px) {
  .navigation-buttons__button__text {
    font-size: 18px;
    line-height: 22px;
  }
  .navigation-buttons {
    margin-top: 90px;
  }
}
</style>
